export default "__VITE_ASSET__wzIW0jJj__"